import { computeIsSellerPov } from '@lib/shared';

import { type DirectSaleItemEntity } from '~/apiClient';

/** Who may reduce a direct sale's price: whoever can act for its company, Customer Service, or the seller's own sales rep. */
export const canReduceSalePrice = (sale: Pick<DirectSaleItemEntity, 'canActForSellerCompany' | 'userMeta'>, isCustomerService: boolean): boolean =>
    computeIsSellerPov({
        isSeller: !!sale.canActForSellerCompany,
        isCustomerService,
        isAssignedSalesRep: !!sale.userMeta?.isSalesRep && !!sale.userMeta?.isSellerSalesRep,
    });
